import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/homepage';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function HeroSection() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollReveal(0.1);

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20red%20carpet%20event%20scene%20with%20paparazzi%20flashes%2C%20mysterious%20atmosphere%2C%20warm%20golden%20and%20deep%20crimson%20tones%2C%20abstract%20blurred%20crowd%20background%2C%20cinematic%20photography%20with%20soft%20bokeh%20lights%2C%20luxurious%20yet%20edgy%20vibe%2C%20editorial%20magazine%20quality%20with%20dramatic%20contrast&width=1920&height=1200&seq=hero-bg-home&orientation=landscape"
          alt="每日大赛黑料网 - 一手爆料"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      {/* Content */}
      <div ref={titleRef} className={`relative z-10 w-full max-w-[900px] mx-auto px-6 flex flex-col items-center pt-20 reveal-up ${titleVisible ? 'visible' : ''}`}>
        {/* Tag line */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-8">
          <i className="ri-fire-fill text-accent-400 text-sm"></i>
          <span className="text-background-50/90 text-sm font-medium whitespace-nowrap">
            网红塌房现场 · 一手爆料
          </span>
        </div>

        {/* Main title */}
        <h1 className="text-center font-heading">
          <span className="block text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight">
            每日大赛黑料网
          </span>
          <span className="block text-xl md:text-2xl lg:text-3xl font-light text-background-50/80 mt-4 leading-relaxed">
            一键吃瓜 · 爆料不停 · 黑料每日更新
          </span>
        </h1>

        {/* CTA */}
        <div className="flex items-center gap-4 mt-10">
          <Link
            to="/"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-base rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            立即吃瓜
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border border-background-50/40 text-background-50 font-medium text-base rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>

      {/* Bottom Featured Cards - staggered 3D effect */}
      <div ref={cardsRef} className={`relative z-10 w-full max-w-[1100px] mx-auto px-6 mt-16 md:mt-20 pb-10 reveal-up ${cardsVisible ? 'visible' : ''}`}>
        <div className="grid grid-cols-3 gap-4 md:gap-6 items-end">
          {featuredArticles.map((article, index) => {
            const isCenter = index === 1;
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className={`relative group rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 hover:scale-105 ${
                  isCenter
                    ? 'z-20 -mt-6 md:-mt-10 shadow-2xl shadow-black/30'
                    : 'z-10 opacity-90 hover:opacity-100'
                }`}
                style={{
                  transform: isCenter
                    ? 'scale(1.08)'
                    : index === 0
                      ? 'rotateY(2deg) translateZ(-20px)'
                      : 'rotateY(-2deg) translateZ(-20px)',
                }}
              >
                <div className="aspect-[3/4] relative">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top"
                    title={article.title}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

                  {/* Tag badge */}
                  <div className="absolute top-3 left-3">
                    <span className={`px-2.5 py-1 rounded-md text-background-50 text-xs font-bold ${article.tagColor}`}>
                      {article.tag}
                    </span>
                  </div>

                  {/* Bottom content */}
                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                    <span className="text-background-50/70 text-xs font-medium mb-1.5 block">
                      {article.category}
                    </span>
                    <h3 className="text-background-50 font-bold text-sm md:text-base leading-snug line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-background-50/60 text-xs mt-1.5 line-clamp-1 hidden md:block">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 mt-2.5 text-background-50/50 text-xs">
                      <span>{article.date}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}